export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=401e5aa74fb04a8d3403f0220b95f94320ab029d82&name=revalidateCommunity!'